import _ from 'underscore';

import { Charting }                                          from '../../../types/charting';
import { useChartReportExport }                              from './useChartReportExport';
import { formatCurrency, percentage, roundToPrecision, sum } from '../../../util';

type ReportChartType = Charting.Reports.BudgetTotalsByCostType.ChartingType;
type ReportChartData = Charting.Reports.BudgetTotalsByCostType.ChartingData;

type HookType = Charting.Reporting.ChartReportExportHookMethod<ReportChartType, ReportChartData>;
type HookOptions = Charting.Reporting.ChartReportExportHookOptions<ReportChartType>;

export const useBudgetTotalsByCostTypeChartReportExport: HookType = ( options: HookOptions ) => {
	
	const defaultHandlers = useChartReportExport( options );
	
	/* Generate text/ string */
	const generateReportText: ReturnType<HookType>['generateReportText'] = ( data ) => {
		
		//@ts-ignore
		let text = generateCSVData( data ).data.map( ( { type, total, percentage } ) => {
			
			return `- ${ type }: ${ total } (${ percentage })`;
		} );
		
		return [ data.datasets[ 0 ].label, ...text ].join( '\n' );
	}
	
	/* Generate CSV Headers + Data */
	const generateCSVData: ReturnType<HookType>['generateCSVData'] = ( data ) => {
		
		// [ Cost Type, Total, Precentage (%) of Cost ]
		let csvHeaders = [
			
			{ label: "Cost Type", key: "type" },
			{ label: "Total", key: "total" },
			{ label: "Precentage (%) of Cost", key: "percentage" },
		];
		
		const dataValues = data.datasets[ 0 ].data;
		
		let csvData = dataValues.map( ( datapointValue, index ) => {
			return {
				type:       data.labels[ index ],
				total:      formatCurrency( datapointValue, true, false ),
				percentage: `${ roundToPrecision( percentage( datapointValue, sum( dataValues ) ), 2 ) }%`
			}
		} );
		
		return {
			headers:  csvHeaders,
			data:     csvData,
			filename: `Report - ${ options.title }.csv`,
			target:   '_blank',
		}
	}
	
	return {
		generateReportText,
		generateCSVData,
		handleCopiedtoClipboard: defaultHandlers.handleCopiedtoClipboard,
		handleCSVGenerated:      defaultHandlers.handleCSVGenerated,
		handleSaveAsImage:       defaultHandlers.handleSaveAsImage,
	};
};
